import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const sizes = {
  small: 130,
  medium: 200,
  large: 300,
};

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 8px;
  grid-template-columns: ${(props) =>
    `repeat(auto-fill, minmax(${sizes[props.size]}px, 1fr))`};
`;

const Grid = ({ children, size }) => {
  return <GridContainer size={size}>{children}</GridContainer>;
};

Grid.propTypes = {
  children: PropTypes.node,
  size: PropTypes.string,
};

Grid.defaultProps = {
  size: 'medium',
};

export default Grid;
